module.exports = __webpack_public_path__ + "images/0d4015206d5ddf796a17f9a036c22979041e8fd51944fe03d6832ff061d91e09.svg";